import { useQuery } from '@tanstack/react-query';
import { USER_CONTACTS_KEY } from '../../utils/constants/queryKeys';
import { getUserContacts } from '../services/fn-api/User';

export const useGetUserContacts = (userId?: number, isPrincipal?: boolean) => {
  return useQuery({
    queryKey: [USER_CONTACTS_KEY, userId, isPrincipal],
    queryFn: async () => {
      if (userId === undefined) throw new Error('User ID is required');
      return getUserContacts(userId, isPrincipal);
    },
    enabled: !!userId,
  });
};
